/**
 * The below file contains the origin area state objects
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  SET_ALL_ORIGIN_AREA,
} from "redux/constants/OriginArea";

//Initial state
const initState = {
  // Keys for dropdown 
  originAreas: [],
  isOriginAreaDataFetched: false,
  // Keys for dropdown 
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const originArea = (state = initState, action) => {
  switch (action.type) {
    //Cases for Origin Area dropdown
    case SET_ALL_ORIGIN_AREA:
      return {
        ...state,
        originAreas: action.payload,
        isOriginAreaDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };
    //Cases for Origin Area dropdown

    default:
      return state;
  }
};

export default originArea;
